module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8517/img/iphone-frame.png"